"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaunchRequest = void 0;
const ws_1 = __importDefault(require("ws"));
const cross_fetch_1 = __importDefault(require("cross-fetch"));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
if (!global.WebSocket) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    global.WebSocket = ws_1.default;
}
const rxjs_1 = require("rxjs");
const jsonwebtoken_1 = __importDefault(require("jsonwebtoken"));
const LaunchStatusType_1 = require("./LaunchStatusType");
class LaunchRequest {
    constructor(id, status, access_token, model, projectId, projectAccessToken) {
        this.id = id;
        this.projectId = projectId;
        this.model = model;
        this.accessToken = access_token;
        this.projectAccessToken = projectAccessToken;
        const decodedAccessToken = jsonwebtoken_1.default.decode(this.accessToken);
        this.launchStatusUrl = decodedAccessToken['aud'];
        if (this.id != decodedAccessToken['sub']) {
            throw new Error('The launch request id does not match the access token provided');
        }
        const decodedProjectAccessToken = jsonwebtoken_1.default.decode(this.projectAccessToken);
        this.issuer = decodedProjectAccessToken['iss'];
        this.status = new rxjs_1.BehaviorSubject({
            status: LaunchStatusType_1.LaunchStatusType.Unknown
        });
        this.ws = new WebSocket(this.launchStatusUrl, this.accessToken);
        this.ws.onmessage = (ev) => {
            const launchStatus = JSON.parse(ev.data);
            this.status.next(launchStatus);
        };
        this.ws.onerror = (ev) => {
            if (this.intervalTimer) {
                clearInterval(this.intervalTimer);
                this.intervalTimer = null;
            }
            this.status.error(ev);
        };
        this.ws.onopen = ( /*ev: Event*/) => {
            this.intervalTimer = setInterval(() => {
                this.ws.send('heartbeat');
            }, 60 * 1000);
            this.getLaunchRequestStatus().then(({ status, message }) => this.status.next({ status, message }));
        };
        this.ws.onclose = ( /*ev: CloseEvent*/) => {
            if (this.intervalTimer) {
                clearInterval(this.intervalTimer);
                this.intervalTimer = null;
            }
            this.status.complete();
        };
    }
    cancel() {
        return __awaiter(this, void 0, void 0, function* () {
            const cancelledStatusResult = yield this.updateLaunchStatus({
                status: LaunchStatusType_1.LaunchStatusType.Cancelled,
                message: 'Agent-initiated cancel'
            });
            return cancelledStatusResult;
        });
    }
    service() {
        return __awaiter(this, void 0, void 0, function* () {
            const servicedStatusResult = yield this.updateLaunchStatus({
                status: LaunchStatusType_1.LaunchStatusType.Serviced,
                message: 'Stream has been consumed by the client'
            });
            return servicedStatusResult;
        });
    }
    updateLaunchStatus(statusUpdate) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield cross_fetch_1.default(this.issuer + `/launchrequest/${this.id}`, {
                method: 'PUT',
                headers: {
                    'content-type': 'application/json',
                    Authorization: 'Bearer ' + this.projectAccessToken
                },
                mode: 'cors',
                body: JSON.stringify(statusUpdate)
            });
            return res.status === 200;
        });
    }
    getLaunchRequestStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield cross_fetch_1.default(this.issuer + `/launchrequest/${this.id}`, {
                method: 'GET',
                headers: {
                    'content-type': 'application/json',
                    Authorization: 'Bearer ' + this.projectAccessToken
                },
                mode: 'cors'
            });
            const result = yield res.json();
            return result;
        });
    }
}
exports.LaunchRequest = LaunchRequest;
//# sourceMappingURL=LaunchRequest.js.map